angular.module("events")
    .controller("pushNotificationsEventEditCtrl", ['$uibModal', '$rootScope', '$scope', '$http', '$stateParams', 'Restangular', '$state', 'modalService', '$filter', 'gridService', 'logService',
        function ($uibModal, $rootScope, $scope, $http, $stateParams, Restangular, $state, modalService, $filter, gridService, logService) {

        $rootScope.title = $filter('translate')('push_notifications.title');
        logService.debug($stateParams.notificationId);
        $scope.showData = 'showInfo';

        $scope.sent = 0;
        $scope.sending = 0;
        $scope.error = 0;
        $scope.eventId = null;

        if (typeof ($stateParams.id) !== 'undefined') {
            $scope.eventId = $stateParams.id;
        }

        if (angular.isUndefined($stateParams.notificationId) || $stateParams.notificationId == "") {
            $scope.company = {
                name: '',
                created_at: new Date()
            };
        }

        $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
            { title: $filter('translate')('push_notifications.title'), url: "events.edit.push_notifications({ id: " + $scope.event.id + " })" },
            { title: $filter('translate')('push_notifications.view') }
        ];


        //Filtro por el estado de la petición 

        let status_filter = "none";

        $scope.filterSent = function () {
            status_filter = "sent";
            logService.debug(status_filter);
            $scope.gridOptions.loadData();
        };

        $scope.filterPending = function () {
            status_filter = "pending";
            logService.debug(status_filter);
            $scope.gridOptions.loadData();
        };
        $scope.filterError = function () {
            status_filter = "error";
            logService.debug(status_filter);
            $scope.gridOptions.loadData();
        };
        $scope.filterNone = function () {
            status_filter = "none";
            logService.debug(status_filter);
            $scope.gridOptions.loadData();
        };



        $scope.gridOptions = {
            pdfTitle: $filter('translate')('push_notifications.users_title'),
            exporterMenuCsv: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [15, 30, 45],
            paginationPageSize: 15,
            // rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },

            columnDefs: [
                { name: 'FK_users_notifications_users.name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false },
                {
                    name: 'status', displayName: $filter('translate')('user_notifications.status'), enableFiltering: true, enableHiding: false, enableColumnMenu: false,
                    cellTemplate: '<div class="ui-grid-cell-contents"> <span class= "label label-meddium  {{row.entity.label}}"}}>{{row.entity.status_name}}</span></div>',
                },
            ],
            getData: function (options) {

                $scope.sent = 0;
                $scope.sending = 0;
                $scope.error = 0;

                return Restangular.one('PushNotifications/One', $stateParams.notificationId).get().then(function (result) {
                    $scope.notification = result;
                    let data = result.FK_users_notifications_notifications;

                    data.forEach(user => {
                        switch (user.status) {
                            case "sent":
                                user.label = " label-primary";
                                user.status_name = $filter('translate')('notifications.sent');
                                $scope.sent++;
                                break;
                            case "pending":
                                user.label = " label-default";
                                user.status_name = $filter('translate')('notifications.sending');
                                $scope.sending++;
                                break;
                            case "error":
                                user.label = " label-danger";
                                user.status_name = $filter('translate')('notifications.sent_error');
                                $scope.error++;
                                break;
                        }
                    })

                    switch (status_filter) {

                        case "sent":
                            data = data.filter((user) => user.status == "sent")
                            break;
                        case "pending":
                            data = data.filter((user) => user.status == "pending")
                            break;
                        case "error":
                            data = data.filter((user) => user.status == "error")
                            break;

                    };

                    return data;


                });
            }
        }





        $scope.cancel = function () {
            $state.go("events.edit.push_notifications", { id: $scope.event.id });
        }
    }])


    ;